interface ClampOptions {
  value: number;
  min?: number;
  max?: number;
}

/**
 * @description Auxiliar function responsible for limiting a value between min and max value
 * @param value
 * @param min
 * @param max
 * @returns result - Result values restricted by min and max
 *
 */
export default function clamp({ value, min = 0, max = Infinity }: ClampOptions): number {
  return Math.min(max, Math.max(min, value));
}
